import { catchError } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { throwError } from 'rxjs/internal/observable/throwError';

import { UcrSecurityService } from '../ucr-security/ucr-security.service';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
    constructor(private inj: Injector) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Clone the request to add the new headers.
        const modifiedReq = req.clone({
            headers: req.headers
                .set('X-Requested-With', 'XMLHttpRequest')
                .set('Cache-Control', 'no-cache')
                .set('Pragma', 'no-cache')
        });

        // Send the newly created request
        return next.handle(modifiedReq).pipe(
            catchError((error: HttpErrorResponse, caught) => {
                // Handle 401 error
                if (error.status === 401) {
                    // if not authenticated
                    const ucrSecurity: UcrSecurityService = this.inj.get(UcrSecurityService);
                    ucrSecurity.login();
                }

                // Return the error to the method that called it
                return throwError(error);
            })
        ) as any;
    }
}
